module.exports = __webpack_public_path__ + "static/img/dynamici.504b7ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamici.png
// module id = CnjH
// module chunks = 45